<template>
  <h3 class="pb5">Rapport statistique détaillé de vigilance (CDX_0236)</h3>
  <CritereRechercheComiteDeVigilance ref="critereRechercheComiteDeVigilance"/>
  <ButtonBar @imprimer="imprimer" @fermer="fermer"/>

</template>

<script>
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import CritereRechercheComiteDeVigilance from "@/components/rapports/Rechercher/CritereRechercheComiteDeVigilance.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "StatistiqueVigilanceDetaille",
  components: {CritereRechercheComiteDeVigilance, ButtonBar},
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Comité de vigilance");
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$store.dispatch("narration/rechercherDefaut48HeuresAction")
        .then((res) => {
          this.assignerResultat(res);
        });
  },
  methods: {
    assignerResultat(res) {
      if (res.data.entites !== null)
        this.$refs.critereRechercheComiteDeVigilance.assignerListe(res.data.entiteDecision);
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      let criteresRecherche = this.$refs.critereRechercheComiteDeVigilance.getCriteresRecherche();
      criteresRecherche.titre = "StatistiqueVigilanceDetaille";
      criteresRecherche.nomRapport = "vigilance.StatistiqueVigilanceDetailleGenerateurRapport_CDX_0236";
      this.$store.dispatch("rapports/obtenirRapportAction", criteresRecherche)
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    },
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
}
</script>

<style scoped>

</style>